<template>
  <div class="new-stock">
    <div>
      <DocumentInfo
        ref="documentRef"
        :form-data="formData"
        :ai-audit-type="2"
      ></DocumentInfo>
    </div>
    <div class="product">
      <ProductTable
        ref="productRef"
        :form-data="productTableData"
      ></ProductTable>
    </div>
    <div class="footer-container">
      <div class="footer-content">
        <span>总计：</span>
        <span class="price">{{ formattedPrice(price) }}</span>
      </div>
      <div class="footer-btn" @click="submit">保存库存信息</div>
    </div>
    <sub-supplier-dialog
      v-if="showSubSupplierTip"
      :showSubSupplierTip.sync="showSubSupplierTip"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import api from '@/modules/projectA/api/order';
import userApi from '@/modules/projectA/api/user';
import DocumentInfo from './components/DocumentInfo.vue';
import ProductTable from './components/ProductTable.vue';
import subSupplierDialog from '../components/subSupplierDialog.vue';
import { formattedPrice } from '../common/stockOrder';

export default {
  components: { DocumentInfo, ProductTable, subSupplierDialog },
  data() {
    return {
      price: 0,
      id: '',
      // 单据信息里面数据
      formData: {
        supplierCompanyName: '',
        remark: '',
        stockAffirmIdList: '',
        purchasePlanList: [],
        attachList: [],
        purchaseDate: '',
        contractAttachList: [],

        oneCategoryValue: '',
        twoCategoryValue: '',
        threeCategoryValue: '',
        lbbm: '',
        categoryId: '',
      },
      productTableData: {
        skuList: [],
      },
      showSubSupplierTip: false,
    };
  },
  computed: {},
  mounted() {
    this.price = this.$refs.productRef.columnTotalPrice;
    this.$watch(
      () => this.$refs.productRef.columnTotalPrice,
      (newValue) => {
        if (!Number.isNaN(newValue)) {
          this.price = newValue;
        }
      }
    );

    // 编辑
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      this.loading = true;
      try {
        const { code, data = {} } = await api.ecStockDetail({ id: this.id });
        if (code === '200') {
          this.formData = { ...data };
          this.formData.purchasePlanList = data.ecAndPetroList || [];
          this.formData.stockAffirmIdList = this.formData.ecAndPetroList
            .map((item) =>
              item.stockAffirmId ? item.stockAffirmId : item.orderNo
            )
            .join(',');

          console.log(this.formData, 'gggggggggggggggggggggggggg');

          this.productTableData.skuList = data.skuList || [];
          this.productTableData.skuList.forEach((item) => {
            if (!item.hasOwnProperty('price')) {
              this.$set(item, 'price', '');
            }
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    formattedPrice,
    async ecStockAdd(params) {
      console.log(params, 'fffff33333333333333333');

      const { code = -1 } = await api.ecStockAdd(params);
      if (code === '200') {
        this.$message.success('新增成功');
        this.$router.push({
          path: '/rawMaterialOrder/stockOrder',
        });
      }
    },
    async submit() {
      console.log(
        this.$refs.documentRef.$refs.documentForm.model,
        'this.$refs.documentRef.$refs.documentForm'
      );
      // 判断是否在供应商清单中
      const { supplierCompanyName } =
        this.$refs.documentRef.$refs.documentForm.model;
      if (supplierCompanyName.length > 0) {
        const res = await userApi.isSubSupplier({
          supplierCompanyNameList: [supplierCompanyName],
        });
        if (res.code === '200') {
          if (res.data.filter((item) => !item.flag).length > 0) {
            this.showSubSupplierTip = true;
            return;
          }
        }
      }

      Promise.all([
        this.$refs.documentRef.$refs.documentForm.validate(),
        this.$refs.productRef.$refs.productForm.validate(),
        this.$refs.documentRef.$refs.commonRef.$refs.commonUpload.validate(),
      ])
        .then(([v1, v2, v3]) => {
          if (v1 && v2 && v3) {
            const docForm = _.omit(this.$refs.documentRef.ruleForm, [
              'purchasePlanNames',
            ]);
            const { skuList = [] } = this.$refs.productRef.tableFormData;
            const { ruleForm } = this.$refs.documentRef.$refs.commonRef;
            const { price } = this;
            const params = { ...docForm, skuList, price, ...ruleForm };

            if (this.id) {
              /* params.ecAndPetroMallList = params.ecAndPetroList.map(({ id, purchasePlanId, type }) => ({
                id: id || purchasePlanId,
                type,
              })); */
              if (params.ecAndPetroList) {
                params.ecAndPetroMallList = params.ecAndPetroList.map(
                  ({ id, purchasePlanId, type }) => ({
                    id: id || purchasePlanId,
                    type,
                  })
                );
              }
              console.log(params, 'params');
              console.log(docForm, 'docForm');
              this.ecStockModify(params);
            } else {
              /* params.ecAndPetroMallList = params.ecAndPetroList.map(({ id, type }) => ({ id, type })); */
              if (params.ecAndPetroList) {
                params.ecAndPetroMallList = params.ecAndPetroList.map(
                  ({ id, type }) => ({ id, type })
                );
              }
              this.ecStockAdd(params);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    // 编辑
    async ecStockModify(params) {
      const { code = -1 } = await api.ecStockModify({ ...params, id: this.id });
      if (code === '200') {
        this.$message.success('编辑成功');
        this.$router.push({
          path: '/rawMaterialOrder/stockOrder',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.new-stock {
  .product {
    margin-top: 20px;
  }
  .footer-container {
    display: flex;
    margin-top: 20px;
    height: 60px;
    background: #fff;
    .footer-content {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      min-width: 0;
      .price {
        margin: 0 20px 0 10px;
        font-size: 18px;
        color: #f0250f;
        font-weight: 500;
      }
    }
    .footer-btn {
      cursor: pointer;
      flex-shrink: 0;
      width: 140px;
      line-height: 60px;
      text-align: center;
      background: #f0250f;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
